import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { Field, change, untouch } from "redux-form";
import { useDispatch } from "react-redux";
import { validateRequired } from "../validation";
import { renderTextAreaField } from "../components";

const translationStyle = { lineHeight: 2 };

export const renderField = ({
  input,
  label,
  type,
  style,
  onClick,
  meta: { touched, error, warning },
}) => (
  <div>
    <input {...input} type={type} style={style} onClick={onClick} />

    {touched &&
      ((error && <div className="field__error">{error}</div>) ||
        (warning && <div className="field__error">{warning}</div>))}
  </div>
);

renderField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  meta: PropTypes.object,
};

const RadioButton = props => {
  const dispatch = useDispatch();
  //reset the respective fields's value with the error if any
  const resetFields = (formName, fieldsArray) => {
    fieldsArray.map(field => {
      //reset the field's value
      dispatch(change(formName, field, ""));

      //reset the field's error
      dispatch(untouch(formName, field));
    });
  };
  let style;
  if (props.optionsIndex == props.optionsLength - 1) {
    style = {
      textAlign: "center",
      borderRight: "1px solid #000",
      ...props.style,
    };
  } else {
    style = { textAlign: "center", ...props.style };
  }

  const handleRadioChange = event => {
    const { name, value } = event.target;

    // Update the state with the selected option for the radio button group
    props.setRadioSelections({ ...props.radioSelections, [name]: value });

    if (value === "No" && name) {
      const id = name.substring(name.length - 1);
      const PatientAndSickness = `PatientAndSickness${id}`;
      const TreatmentDateFrom = `TreatmentDateFrom${id}`;
      const TreatmentDateTo = `TreatmentDateTo${id}`;
      const TreatmentDetail = `TreatmentDetail${id}`;
      const Recovery = `Recovery${id}`;
      const DoctorAndAddress = `DoctorAndAddress${id}`;
      resetFields("axaHdf", [
        PatientAndSickness,
        TreatmentDateFrom,
        TreatmentDateTo,
        TreatmentDetail,
        Recovery,
        DoctorAndAddress,
      ]);
    }
  };

  return (
    <td style={style}>
      <Field
        name={props.questionId}
        type="radio"
        component={renderField}
        value={props.value}
        validate={validateRequired}
        onClick={handleRadioChange}
      />
      <div style={{ margin: "8px" }}>{props.value}</div>
    </td>
  );
};

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  optionsIndex: PropTypes.number.isRequired,
  optionsLength: PropTypes.number.isRequired,
  questionId: PropTypes.string.isRequired,
  setRadioSelections: PropTypes.func.isRequired,
  radioSelections: PropTypes.object.isRequired,
  style: PropTypes.object,
};

export const RadioButtonGroupRow = props => {
  const optionsYesNo = ["Yes", "No"];
  const style = {
    padding: "10px",
    borderLeft: "1px solid #000",
    borderRight: "1px solid #000",
    ...props.style,
  };

  const elements = [];

  elements.push(
    <td style={style} key={props.questionId}>
      {props.questionDesc1}
      <div style={{ marginTop: "10px", ...translationStyle }}>{props.questionDesc2}</div>
    </td>
  );

  optionsYesNo.forEach((option, index) =>
    elements.push(
      <RadioButton
        key={`${props.questionId}${index}`}
        value={option}
        optionsIndex={index}
        optionsLength={optionsYesNo.length}
        questionId={props.questionId}
        setRadioSelections={props.setRadioSelections}
        radioSelections={props.radioSelections}
        style={props.style}
      />
    )
  );
  return <tr>{elements}</tr>;
};

RadioButtonGroupRow.propTypes = {
  questionId: PropTypes.string.isRequired,
  questionDesc1: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  questionDesc2: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  setRadioSelections: PropTypes.func.isRequired,
  radioSelections: PropTypes.object.isRequired,
  style: PropTypes.object,
};

const HealthQuestions = ({ values, renderValue, isReadOnly }) => {
  const [radioSelections, setRadioSelections] = useState({});
  let appendRows = [];
  for (let key in radioSelections) {
    if (radioSelections[key] === "Yes" && key !== "Question1") appendRows.push(key);
  }

  for (let i = 2; i <= 9; i++) {
    const key = `Question${i}`;
    if (values && !appendRows.includes(key) && values[key] === "Yes") {
      appendRows.push(key);
    }
  }
  appendRows.sort((a, b) => a.localeCompare(b));
  return (
    <Fragment>
      <table style={{ borderCollapse: "collapse", width: "100%", tableLayout: "fixed" }}>
        <tbody>
          <tr>
            <td
              rowSpan={2}
              style={{
                borderBottom: "1px solid #000",
                paddingLeft: 0,
                width: "80%",
                wordWrap: "break-word",
              }}
            >
              <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                All Questions must be answered “Yes” or “No” 以下所有的問題必須答“是”或“否” Y/N
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                borderBottom: "1px solid #000",
                textAlign: "center",
              }}
            ></td>
            <td
              style={{
                borderBottom: "1px solid #000",
                textAlign: "center",
              }}
            ></td>
          </tr>
          <RadioButtonGroupRow
            questionDesc1="1)   Are you now on a full-time basis and active in your job? 閣下是否全職僱員及現時是否正常工作？"
            questionId="Question1"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
          />
          <RadioButtonGroupRow
            questionDesc1="2)   To the best of your knowledge, do you or your dependant(s)
          (if applicable) have any physical impairment or deformity or departure from good health?"
            questionDesc2="照閣下所知，閣下或貴家屬是否有身體缺陷、畸形、或身體不正常？"
            questionId="Question2"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
            style={{ borderTop: "1px solid #000" }}
          />
          <RadioButtonGroupRow
            questionDesc1="3) Have you or your dependant(s) (if applicable) had,
          or been advised to have an X-ray, ECG or blood test
          (eg. Cholesterol, AIDS, Hepatitis including Hepatitis B, Anaemia etc) in the last five years?"
            questionDesc2="在過去五年內，閣下或貴家屬有否接受或被建議接受X光檢查，
          心電圖或血液檢驗？（例如膽固醇，後天免疫缺乏症，肝炎包括乙型肝炎，貧血等）？"
            questionId="Question3"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
            style={{ borderTop: "1px solid #000" }}
          />
          <RadioButtonGroupRow
            questionDesc1="4) Have you or your dependant(s) (if applicable)
          had a surgical operation or been confined or treated in any hospital,
          sanatorium or other institution in the last five years? "
            questionDesc2="在過去五年內，閣下或貴家屬曾否進行過外科手術或療養接受治療？"
            questionId="Question4"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
            style={{ borderTop: "1px solid #000" }}
          />
          <RadioButtonGroupRow
            questionDesc1="5) Have you or your dependant(s) (if applicable)
          ever been treated for or been told to have high or low blood pressure;
          heart, vein or artery trouble; rheumatic fever; fainting spells;
          lung or other respiratory trouble; asthma; emphysema; pleurisy; colitis; ulcers;
          stomach, gall bladder, liver, intestinal or rectal trouble; hernia; diabetes;
          any form of tuberculosis; kidney, pancreas, bladder or genito-urinary trouble;
          thyroid trouble; venereal disease, syphilis; mental or nervous trouble; epilepsy;
          gout; brain disorders; arthritis or rheumatism; bone trouble; sciatica;
          back or spinal trouble; cancer; tumours or any form of growth; any deformities;
          paralysis; loss of or loss of the use of an eye or limb; any physical conditions;
          or injuries not previously mentioned, or any symptom of ill health,
          AIDS, AIDS-related complications or AIDS-related conditions?"
            questionDesc2="閣下或貴家屬曾否接受過下列疾病之治療或被報告曾患下列疾病：
          高或低血壓、心臟、靜脈及動脈問題、風濕熱、昏倒病、肺部或呼吸問題、哮喘、氣腫、胸膜炎、結腸炎、
          潰瘍、胃、膽囊、肝或直腸問題、疝氣、糖尿病、任何結核病、腎胰臟、膀胱或生殖及泌尿系統問題、甲狀腺、
          性病、梅毒、精神或神經的問題、羊癎症、痛風、腦部疾病、關節炎或風濕病、骨骼、神經痛、背部或脊骨問題、
          癌症、腫瘤、畸形、癱瘓、喪失聽覺、視覺或肢體、任何其他以上未提及的健康情況、損傷及病徵、
          後天免疫力缺乏症（愛滋病），與愛滋"
            questionId="Question5"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
            style={{ borderTop: "1px solid #000" }}
          />
          <RadioButtonGroupRow
            questionDesc1="6) Are you or your dependant(s) (if applicable) now receiving or
          contemplating to receive any medical or surgical treatment or taking any medication?"
            questionDesc2="閣下或貴家屬現時是否正接受醫生診治，外科手術或藥物治療？"
            questionId="Question6"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
            style={{ borderTop: "1px solid #000" }}
          />
          <RadioButtonGroupRow
            questionDesc1="7) Have you or your dependant(s) (if applicable)
          ever been refused of any form of life or health insurance or ever had a policy rated,
          modified or renewal refused?"
            questionDesc2="閣下或貴家屬曾否購買人壽或醫藥保險而被拒絕，或保留須加保費，更改或被拒絕延續？"
            questionId="Question7"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
            style={{ borderTop: "1px solid #000" }}
          />
          <RadioButtonGroupRow
            questionDesc1="8) Do you smoke tobacco, take drugs or narcotics or alcohol?
          If “Yes”, type and quantity."
            questionDesc2="閣下有否吸煙，服用藥物，毒品或含酒精飲品？如有，請列明種類及份量。"
            questionId="Question8"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
            style={{ borderTop: "1px solid #000" }}
          />
          <RadioButtonGroupRow
            questionDesc1="9) Has either parent or any brother or sister ever had diabetes,
          kidney disease, heart disease, stroke, high blood pressure, coronary artery disease,
          mental illness or cancer?"
            questionDesc2="閣下的父母，兄弟姊妹曾否患有下列疾病、糖尿病、腎病、心臟病、中風、
          高血壓、冠狀動脈病、精神病或癌症？"
            questionId="Question9"
            setRadioSelections={setRadioSelections}
            radioSelections={radioSelections}
            style={{ borderTop: "1px solid #000", borderBottom: "1px solid #000" }}
          />

          <tr>
            <td
              colSpan={3}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                fontWeight: "bold",
                textAlign: "center",
                paddingTop: 10,
              }}
            >
              PLEASE PROVIDE COMPLETE DETAILS OF EACH QUESTION ANSWERED “YES” (If insufficient space
              below, please attach a separate sheet)
              <br />
              <br />
              答是者請將詳細說明列下：(如下列空位不足，請將詳情寫在另一白紙上一併交回)
              <br />
              <br />
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <tbody>
          <tr>
            <td
              rowSpan={2}
              style={{
                border: "1px solid #000",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Question No. <br />
              <br />
              問題編號
            </td>
            <td
              rowSpan={2}
              style={{
                border: "1px solid #000",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Name of Person treated and details of the injury or sickness (Number of attacks and
              severity) <br />
              <br />
              病人姓名及疾病說明 ﹝請列明病發次數及病程﹞
            </td>
            <td
              colSpan={2}
              style={{
                border: "1px solid #000",
                textAlign: "center",
              }}
            >
              Duration 治療
              <br />
              <br />
              Dates 日期
            </td>
            <td
              rowSpan={2}
              style={{
                border: "1px solid #000",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Name of Operation/ Treatment & Result of Tests
              <br />
              <br />
              治療/手術名稱及測試結果
            </td>
            <td
              rowSpan={2}
              style={{
                border: "1px solid #000",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Degree of recovery
              <br />
              <br />
              痊癒程度
            </td>
            <td
              rowSpan={2}
              style={{
                border: "1px solid #000",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Name and Address of Attending Doctor
              <br />
              <br />
              診治醫生姓名及地址
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid #000",
                textAlign: "center",
                ...translationStyle
              }}
            >
              From 由
            </td>
            <td
              style={{
                border: "1px solid #000",
                textAlign: "center",
                ...translationStyle
              }}
            >
              To 至
            </td>
          </tr>
          {appendRows.map(x => {
            const id = x.substring(x.length - 1);
            return (
              <tr key={id}>
                <td style={{ border: "1px solid #000", textAlign: "center" }}>Question {id}</td>
                <td style={{ border: "1px solid #000", textAlign: "center" }}>
                  {isReadOnly ? (
                    renderValue({
                      fieldName: `PatientAndSickness${id}`,
                      fieldFormat: "text",
                    })
                  ) : (
                    <Field
                      name={`PatientAndSickness${id}`}
                      type="text"
                      component={renderTextAreaField}
                      validate={validateRequired}
                      style={{ width: "100%", height: "100%" }}
                    />
                  )}
                </td>
                <td style={{ border: "1px solid #000", textAlign: "center" }}>
                  {isReadOnly ? (
                    renderValue({
                      fieldName: `TreatmentDateFrom${id}`,
                      fieldFormat: "text",
                    })
                  ) : (
                    <Field
                      name={`TreatmentDateFrom${id}`}
                      type="text"
                      component={renderField}
                      validate={validateRequired}
                      style={{ width: "100%" }}
                    />
                  )}
                </td>
                <td style={{ border: "1px solid #000", textAlign: "center" }}>
                  {isReadOnly ? (
                    renderValue({
                      fieldName: `TreatmentDateTo${id}`,
                      fieldFormat: "text",
                    })
                  ) : (
                    <Field
                      name={`TreatmentDateTo${id}`}
                      type="text"
                      component={renderField}
                      validate={validateRequired}
                      style={{ width: "100%" }}
                    />
                  )}
                </td>
                <td style={{ border: "1px solid #000", textAlign: "center" }}>
                  {isReadOnly ? (
                    renderValue({
                      fieldName: `TreatmentDetail${id}`,
                      fieldFormat: "text",
                    })
                  ) : (
                    <Field
                      name={`TreatmentDetail${id}`}
                      type="text"
                      component={renderTextAreaField}
                      validate={validateRequired}
                      style={{ width: "100%" }}
                    />
                  )}
                </td>
                <td style={{ border: "1px solid #000", textAlign: "center" }}>
                  {isReadOnly ? (
                    renderValue({
                      fieldName: `Recovery${id}`,
                      fieldFormat: "text",
                    })
                  ) : (
                    <Field
                      name={`Recovery${id}`}
                      type="text"
                      component={renderTextAreaField}
                      validate={validateRequired}
                      style={{ width: "100%" }}
                    />
                  )}
                </td>
                <td style={{ border: "1px solid #000", textAlign: "center" }}>
                  {isReadOnly ? (
                    renderValue({
                      fieldName: `DoctorAndAddress${id}`,
                      fieldFormat: "text",
                    })
                  ) : (
                    <Field
                      name={`DoctorAndAddress${id}`}
                      type="text"
                      component={renderTextAreaField}
                      validate={validateRequired}
                      style={{ width: "100%" }}
                    />
                  )}
                </td>
              </tr>
            );
          })}
          <tr style={{ height: "30px" }}>
            <td style={{ border: "1px solid #000", textAlign: "center" }}></td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}></td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}></td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}></td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}></td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}></td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}></td>
          </tr>
        </tbody>
      </table>
    </Fragment>
  );
};

HealthQuestions.propTypes = {
  values: PropTypes.object,
  renderValue: PropTypes.func,
  isReadOnly: PropTypes.bool,
};

export default HealthQuestions;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/AXAHD202404/HealthQuestions.js